import { Col, Container, Row, Form } from "react-bootstrap";
import BackArrow from "../../components/backArrow/index";
import { images } from "../../constants";
import { useRef, useState } from "react";
import PersonalImage from "../../helpers/fileUpload";
import Button from "react-bootstrap/Button";
import { useNavigate, useLocation } from "react-router-dom";
import Card from "react-bootstrap/Card";
import ClearIcon from "@mui/icons-material/Clear";
import { currencies } from "../../constants/jsonConstant";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import "./usedvehicle.css";
import { getAsset } from "../../helpers/helper";
const Usedvehicleform = ({
  setUsedvehicle,
  PostVehicleData,
  UpdateVehicleData,
  butn,
  usedvehicle,
  PostItem,
  updateurl,
  index,
  id,
  getInputProps,
  getRootProps,
  displayimg,
  setDisplayimg,
  isUploading,
  uploadProgress,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const InputChange = (e) => {
    setUsedvehicle((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const [uploadedImages, setUploadedImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");

  const removeImage = (index) => {
    const updatedImages = [...displayimg];
    updatedImages.splice(index, 1);
    setDisplayimg(updatedImages);
  };

  const validationSchema = Yup.object({
    modelYear: Yup.string().required("Model year is required*"),
    brandName: Yup.string().required("Brand name is required*"),
    make: Yup.string().required("Make is required*"),
    version: Yup.string().required("Version is required*"),
    registeredIn: Yup.string().required("Registration location is required*"),
    color: Yup.string().required("Exterior color is required*"),
    assembly: Yup.string().required("Assembly is required*"),
    city: Yup.string().required("City is required*"),
    cityArea: Yup.string().required("City area is required*"),
    engineType: Yup.string().required("Engine type is required*"),
    engineCapactiy: Yup.string().required("Engine capacity is required*"),
    currency: Yup.string().required("Currency is required*"),
    mileage: Yup.string().required("Mileage is required*"),
    transmission: Yup.string().required("Transmission is required*"),
    price: Yup.string().required("Price is required*"),
    contact: Yup.string().required("Contact number is required*"),
    description: Yup.string().required("Description is required*"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    values: usedvehicle,
  });

  const onFormSubmit = (data) => {
    if (butn === "Post" && PostItem) {
      PostItem();
    } else if (butn === "Update" && UpdateVehicleData) {
      UpdateVehicleData();
    } else if (butn === "Create" && PostVehicleData) {
      PostVehicleData();
    }
  };

  return (
    <>
      {selectedImage && <PersonalImage image={selectedImage} />}
      <Container>
        <Form onSubmit={handleSubmit(onFormSubmit)}>
          <div className="mt-lg-4 d-flex justify-content-center align-items-center ">
            <Col lg={10} md={12} sm={12} className="Form-Shadow  pb-3">
              <div className="arrowback ">
                <BackArrow black="black" back="/SellingSide" mystyle="ps-3" />
              </div>

              <div className=" mt-2 p-4">
                <Row className="d-flex justify-content-around ">
                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble">Model Year</Form.Label>
                    <Form.Control
                      placeholder="model year"
                      type="number"
                      {...register("modelYear")}
                      className={`labelText input-style p-2 form-control ${errors.modelYear ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("modelYear").onChange(e);
                      }}
                    />
                    {errors.modelYear && (
                      <div className="text-danger font_11 ps-2">
                        {errors.modelYear.message}
                      </div>
                    )}
                  </Col>
                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble">Make</Form.Label>
                    <Form.Control
                      placeholder="make"
                      type="number"
                      {...register("make")}
                      className={`labelText input-style p-2 ${errors.make ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("make").onChange(e);
                      }}
                    />
                    {errors.make && (
                      <div className="text-danger font_11 ps-2">
                        {errors.make.message}
                      </div>
                    )}
                  </Col>
                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble ">Brand Name</Form.Label>
                    <Form.Control
                      placeholder="brandName"
                      type="text"
                      {...register("brandName")}
                      className={`labelText input-style p-2 ${errors.brandName ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("brandName").onChange(e);
                      }}
                    />
                    {errors.brandName && (
                      <div className="text-danger font_11 ps-2">
                        {errors.brandName.message}
                      </div>
                    )}
                  </Col>
                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble ">Version</Form.Label>
                    <Form.Control
                      placeholder="version"
                      type="text"
                      {...register("version")}
                      className={`labelText input-style p-2 ${errors.version ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("version").onChange(e);
                      }}
                    />
                    {errors.version && (
                      <div className="text-danger font_11 ps-2">
                        {errors.version.message}
                      </div>
                    )}
                  </Col>

                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble">
                      Registered In
                    </Form.Label>
                    <Form.Control
                      placeholder="registered"
                      type="text"
                      {...register("registeredIn")}
                      className={`labelText input-style p-2 ${errors.registeredIn ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("registeredIn").onChange(e);
                      }}
                    />
                    {errors.registeredIn && (
                      <div className="text-danger font_11 ps-2">
                        {errors.registeredIn.message}
                      </div>
                    )}
                  </Col>
                </Row>

                <Row className="d-flex justify-content-around">
                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble ">City</Form.Label>
                    <Form.Control
                      placeholder="city"
                      type="text"
                      {...register("city")}
                      className={`labelText input-style p-2 ${errors.city ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("city").onChange(e);
                      }}
                    />
                    {errors.city && (
                      <div className="text-danger font_11 ps-2">
                        {errors.city.message}
                      </div>
                    )}
                  </Col>
                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble">City Area</Form.Label>
                    <Form.Control
                      placeholder="area"
                      type="text"
                      {...register("cityArea")}
                      className={`labelText input-style p-2 ${errors.cityArea ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("cityArea").onChange(e);
                      }}
                    />
                    {errors.cityArea && (
                      <div className="text-danger font_11 ps-2">
                        {errors.cityArea.message}
                      </div>
                    )}
                  </Col>

                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble ">
                      Exterior Color
                    </Form.Label>
                    <Form.Control
                      placeholder="color"
                      type="text"
                      {...register("color")}
                      className={`labelText input-style p-2 ${errors.color ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("color").onChange(e);
                      }}
                    />
                    {errors.color && (
                      <div className="text-danger font_11 ps-2">
                        {errors.color.message}
                      </div>
                    )}
                  </Col>

                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble">Assembly</Form.Label>
                    <Form.Control
                      placeholder="assembly"
                      type="text"
                      {...register("assembly")}
                      className={`labelText input-style p-2 ${errors.assembly ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("assembly").onChange(e);
                      }}
                    />
                    {errors.assembly && (
                      <div className="text-danger font_11 ps-2">
                        {errors.assembly.message}
                      </div>
                    )}
                  </Col>
                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble">Engine Type</Form.Label>
                    <Form.Control
                      placeholder="type"
                      type="text"
                      {...register("engineType")}
                      className={`labelText input-style p-2 ${errors.engineType ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("engineType").onChange(e);
                      }}
                    />
                    {errors.engineType && (
                      <div className="text-danger font_11 ps-2">
                        {errors.engineType.message}
                      </div>
                    )}
                  </Col>
                </Row>

                <Row className="d-flex justify-content-around mt-2">
                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble">
                      Engine Capacity*(cc)
                    </Form.Label>
                    <Form.Control
                      placeholder="capacity"
                      type="number"
                      {...register("engineCapactiy")}
                      className={`labelText input-style p-2 ${errors.engineCapactiy ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("engineCapactiy").onChange(e);
                      }}
                    />
                    {errors.engineCapactiy && (
                      <div className="text-danger font_11 ps-2">
                        {errors.engineCapactiy.message}
                      </div>
                    )}
                  </Col>
                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble">
                      Mileage * (km)
                    </Form.Label>
                    <Form.Control
                      placeholder="mileage"
                      type="number"
                      {...register("mileage")}
                      className={`labelText input-style p-2 ${errors.mileage ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("mileage").onChange(e);
                      }}
                    />
                    {errors.mileage && (
                      <div className="text-danger font_11 ps-2">
                        {errors.mileage.message}
                      </div>
                    )}
                  </Col>
                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble">Transmission</Form.Label>
                    <Form.Control
                      placeholder="transmission"
                      type="text"
                      {...register("transmission")}
                      className={`labelText input-style p-2 ${errors.transmission ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("transmission").onChange(e);
                      }}
                    />
                    {errors.transmission && (
                      <div className="text-danger font_11 ps-2">
                        {errors.transmission.message}
                      </div>
                    )}
                  </Col>

                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble">Price* (Rs)</Form.Label>
                    <Form.Control
                      placeholder="price"
                      type="number"
                      {...register("price")}
                      className={`labelText input-style p-2 ${errors.price ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("price").onChange(e);
                      }}
                    />
                    {errors.price && (
                      <div className="text-danger font_11 ps-2">
                        {errors.price.message}
                      </div>
                    )}
                  </Col>
                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble">
                      Select Currency
                    </Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      {...register("currency")}
                      className={`labelText input-style p-2 ${errors.currency ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("currency").onChange(e);
                      }}
                    >
                      {usedvehicle?.currency?.length > 0 ? (
                        <option> {usedvehicle?.currency}</option>
                      ) : (
                        <option>Select</option>
                      )}
                      {currencies.map((e) => (
                        <option key={e.abbreviation}>
                          {e.abbreviation} {e.name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.currency && (
                      <div className="text-danger font_11 ps-2">
                        {errors.currency.message}
                      </div>
                    )}
                  </Col>
                </Row>

                <Row className="ps-3">
                  <Col md={2} lg={2} className="p-0">
                    <Form.Label className="custm-lble">
                      Contact Number
                    </Form.Label>
                    <Form.Control
                      placeholder="number"
                      type="number"
                      {...register("contact")}
                      className={`labelText input-style p-2 ${errors.contact ? "is-invalid" : ""}`}
                      onChange={(e) => {
                        InputChange(e);
                        register("contact").onChange(e);
                      }}
                    />
                    {errors.contact && (
                      <div className="text-danger font_11 ps-2">
                        {errors.contact.message}
                      </div>
                    )}
                  </Col>
                </Row>

                <div className=" pt-3 pb-2 ps-2 pe-2">
                  <Form.Label className="custm-lble pb-1">
                    Description
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={6}
                    {...register("description")}
                    placeholder="Description"
                    className={`input-style ${errors.description ? "is-invalid" : ""}`}
                    onChange={(e) => {
                      InputChange(e);
                      register("description").onChange(e);
                    }}
                  />
                  {errors.description && (
                    <div className="text-danger font_11 ps-2">
                      {errors.description.message}
                    </div>
                  )}
                </div>

                <Col lg="9" className="me-auto">
                  <Row>
                    <Col lg={2} className="mt-2 ms-2">
                      <Card
                        style={{
                          width: "6rem",
                          height: "6rem",
                          position: "relative",
                        }}
                        {...getRootProps()}
                        className="dropzone"
                      >
                        {isUploading ? (
                          <div
                            style={{
                              position: "absolute",
                              inset: 0,
                              background: "rgba(255,255,255,0.7)",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flexDirection: "column",
                              borderRadius: "0.5rem",
                            }}
                          >
                            <div
                              className="spinner-border text-primary"
                              style={{ width: "1.5rem", height: "1.5rem" }}
                              role="status"
                            ></div>
                            <small className="mt-1">{uploadProgress}%</small>
                          </div>
                        ) : (
                          <>
                            <Card.Img
                              className="imet-fit"
                              src={images.AddImage}
                            />
                            <Card.Body>
                              <input
                                type="file"
                                id="file"
                                style={{ display: "none" }}
                                {...getInputProps()}
                                multiple
                                autoComplete="off"
                              />
                            </Card.Body>
                          </>
                        )}
                      </Card>
                    </Col>

                    {displayimg?.length > 0 && (
                      <Col lg={7} className="mt-1 d-flex">
                        {displayimg.map((image, index) => (
                          <Card
                            key={index}
                            className="me-2 mt-1"
                            style={{
                              width: "6rem",
                              height: "6rem",
                              border: "2px solid",
                              position: "relative",
                            }}
                          >
                            <Card.Img
                              className="imet-fit upload-img mt-0"
                              src={getAsset(image)}
                              alt=""
                              crossOrigin="anonymous"
                            />
                            <div
                              className="close-btnone"
                              onClick={() => removeImage(index)}
                            >
                              <ClearIcon />
                            </div>
                          </Card>
                        ))}
                      </Col>
                    )}
                  </Row>
                </Col>

                <div className="btns pe-3">
                  <button
                    className="btn1 "
                    type="button"
                    onClick={() => navigate("/used-vehicle-profile/" + id)}
                  >
                    Cancel
                  </button>
                  <button className="btn2 disable-btn" type="submit">
                    {butn}
                  </button>
                </div>
              </div>
            </Col>
          </div>
        </Form>
      </Container>
    </>
  );
};

export default Usedvehicleform;
